import React from 'react'; // eslint-disable-line import/no-extraneous-dependencies
import Menu from 'react-burger-menu/lib/menus/bubble';
import styles from './mobileMenu.module.css'; // eslint-disable-line no-unused-vars

import Links from '../links';

const menuStyles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    left: '15px',
    top: '15px',
  },
  bmBurgerBars: {
    background: '#373a47',
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenu: {
    background: '#373a47',
    padding: '2.5em 1.5em 0',
    fontSize: '2.15em',
    height: 'calc(100vh)',
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em',
    height: 'calc(100% - 1.6em)',
    display: 'flex',
    flexDirection: 'column',
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
};


class MobileMenu extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.onClickHide = this.onClickHide.bind(this);
  }

  onClickHide() {
    this.setState({
      isOpen: false,
    });
  }


  render() {
    return (
      <Menu className={styles.menu} styles={menuStyles} isOpen={this.state.isOpen} pageWrapId="page-wrap" outerContainerId="outer-container">
        <Links onClickLink={this.onClickHide} />
      </Menu>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/navbar/mobileMenu/index.jsx